export enum ClientInterviewStatus {
  HIRED,
  REJECTED_AFTER_CI,
  RESIGNED_AFTER_CI
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/client-interview-status.enum.ts